export const BASE_URL = 'https://dikooko.herokuapp.com/api/';
export const requestHeaders = {
    headers: {
        'content-type': 'application/json',
    },
};
